import { FC, useCallback } from "react";
import { Button, Stack, Tooltip, Typography } from "@mui/material";

import { CommitmentType } from "@/services/cloudchipr.api";

interface CommitmentsMetadataCardChipButtonProps {
  type: CommitmentType;
  onClick: (commitmentType: CommitmentType) => void;
  value: string;
  tooltipTitle: string;
}

export const CommitmentsMetadataCardChipButton: FC<
  CommitmentsMetadataCardChipButtonProps
> = ({ type, onClick, value, tooltipTitle }) => {
  const label = `${commitmentTypeLabels[type]}:`;

  const clickHandler = useCallback(() => {
    onClick(type);
  }, [type, onClick]);

  return (
    <Button onClick={clickHandler} sx={buttonStyles} disableRipple>
      <Tooltip placement="top" title={tooltipTitle}>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Typography variant="caption">{label}</Typography>
          <Typography variant="caption" fontWeight="medium">
            {value}
          </Typography>
        </Stack>
      </Tooltip>
    </Button>
  );
};

const commitmentTypeLabels: Record<CommitmentType, string> = {
  reservation: "RI",
  savings_plan: "SP",
};

const buttonStyles = {
  color: "primary.main",
  "&:hover": {
    bgcolor: "transparent",
  },
};
